import { FC, memo } from "react";

import { ContentSidebar } from "../sidebar/ContentSidebar";
import { TopicSidebarPanel } from "../topic/TopicSidebarPanel";

import { PlannerSidebarPanel } from "components/materials/section/planner/PlannerSidebarPanel";
import { SectionPageSidebarPanel } from "components/materials/sidebar/SectionPageSidebarPanel";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { selectCurrentSectionIsTemplate } from "store/selectors";
import { SCROLL_TRACKING_IDS } from "utils/hooks/use-scroll-restoration";

export type PageSidebarProps = {
  topicId: string;
  pageId?: string;
};

export const PageSidebar: FC<PageSidebarProps> = memo(
  ({ topicId, pageId }) => {
    const { canAuthorSection } = useCapabilities();
    const isInTemplateSection = useAppSelector(selectCurrentSectionIsTemplate);

    return (
      <ContentSidebar
        AssignmentPanel={<SectionPageSidebarPanel pageCategory="assignment" />}
        context={pageId ? "page" : "section"}
        CourseResourcePanel={<SectionPageSidebarPanel pageCategory="course_resource" />}
        InstructorWorkspacePanel={
          canAuthorSection && <SectionPageSidebarPanel pageCategory="instructor_workspace" />
        }
        pageId={pageId}
        PlannerPanel={
          !isInTemplateSection && (
            <PlannerSidebarPanel scrollTrackingId={SCROLL_TRACKING_IDS.PAGE_SIDEBAR} />
          )
        }
        scrollTrackingId={SCROLL_TRACKING_IDS.PAGE_SIDEBAR}
        TopicsPanel={
          <TopicSidebarPanel
            scrollTrackingId={SCROLL_TRACKING_IDS.PAGE_SIDEBAR}
            topicId={topicId}
          />
        }
      />
    );
  },
  (prevProps, nextProps) => prevProps.topicId === nextProps.topicId,
);

PageSidebar.displayName = "PageSidebar";
